import React from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSelect from './LanguageSelect';
import { languages as languagesConfig } from 'i18n';

const Languages = () => {
  const languages = languagesConfig.map(l => ({
    code: l,
    description: l.toUpperCase(),
  }));
  const { i18n } = useTranslation();
  const [lng, setLng] = React.useState({ code: '', description: '' });

  React.useEffect(() => {
    if (lng.code === '') {
      const lngCode = i18n.language;
      const currentLanguage = languages.find(l => l.code === lngCode);

      setLng(currentLanguage);
    }
  }, [i18n.language, languages, lng]);

  const setLanguage = React.useCallback(
    language => {
      setLng(language);
      i18n.changeLanguage(language.code);
    },
    [i18n],
  );

  const handleChange = event => {
    const value = event.target.value;
    const selectedLanguage = languages.find(l => l.code === value);
    setLanguage(selectedLanguage);
    window.location.reload();
  };

  return languages && languages.length > 0 ? (
    <>
      <LanguageSelect
        languages={languages}
        value={lng}
        onChange={handleChange}
      />
    </>
  ) : null;
};

export default Languages;
